// import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core'

import { MediumEditorDirective } from './medium-editor.directive';

@NgModule({
  imports: [ ],
  exports: [
    MediumEditorDirective
  ],
  declarations: [
    MediumEditorDirective
  ],
})
export class MediumEditorModule { }